import { render, staticRenderFns } from "./FeaturesStep.vue?vue&type=template&id=7c06c1a8&scoped=true&"
import script from "./FeaturesStep.vue?vue&type=script&lang=js&"
export * from "./FeaturesStep.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesStep.vue?vue&type=style&index=0&id=7c06c1a8&scoped=true&lang=css&"
import style1 from "./FeaturesStep.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c06c1a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VIcon,VListItem,VListItemIcon,VRow})
